module.exports = __webpack_public_path__ + "img/icon-5.224e2811.png";